import { useMutation } from '@tanstack/react-query';

import { DispatchEventClient, EventReport } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useCreateNewDispatchEventFromExisting() {
  return useMutation({
    mutationKey: [queryKeys.DispatchEvent.CreateNew],
    mutationFn: (eventReport: EventReport) => dispatchEventClient.createNewFromExisting(eventReport),
  });
}

export default useCreateNewDispatchEventFromExisting;
